import { call, put, takeLatest } from "redux-saga/effects";
import { onValidatePayment, onValidatePaymentSuccess, onValidatePaymentError } from "../Store/Slices/validatePaymentSlice";
import { callValidatePaymentPostApi } from "../Context/validatePaymentApi";

function* ValidatePayment({ payload }) {
  try {
    const getOrderResponse = yield call(callValidatePaymentPostApi, payload);
    if (getOrderResponse.httpStatusCode === "200") {
      yield put(
        onValidatePaymentSuccess({
          data: getOrderResponse.response,
          message: getOrderResponse.response,
        })
      );
    } else {
      yield put(
        onValidatePaymentError({
          data: getOrderResponse.response,
          message: getOrderResponse.errorMessage,
        })
      );
    }
  } catch (error) {
    const message = error?.response?.data?.ErrorMessage || "Something went wrong";
    const errorCode = error?.response?.data?.ErrorCode || error?.response?.data?.errorCode;
    yield put(onValidatePaymentError({ data: {}, message, status_code: error?.response?.data?.HttpStatusCode || 400, errorCode }));
  }
}

export default function* validatePaymentSaga() {
  yield takeLatest(onValidatePayment.type, ValidatePayment);
}